module.exports = __webpack_public_path__ + "media/images/illustrations/starworks-star-warning-a5098ecf4e42866267f564925f7c3cb7.svg";